import React, { useState, useEffect, Fragment } from "react";
import {
  Avatar,
  Box,
  Button,
  Group,
  Menu,
  Modal,
  Text,
  createStyles,
} from "@mantine/core";
import ConfirmModal from "../../components/CustomModal";

import Layout from "../../components/ReusableLayout.";
import { useMedplum, useMedplumContext } from "@medplum/react";
import { normalizeErrorString } from "@medplum/core";
import { useSelector } from "react-redux";
import ReusableCard from "../../components/ReusableCard";
import gfit from "../../assets/img/Googlefit.svg";
import epic from "../../assets/img/epic.svg";
import omron from "../../assets/img/omronLogo.png";
import withing from "../../assets/img/withingsLogo.png";
import strava from "../../assets/img/stravaLogo.png";
import { Loader } from "@mantine/core";
import eclinical from "../../assets/img/eclinical.svg";
import apple from "../../assets/img/apple.svg";
import cerner from "../../assets/img/cerner.svg";
import nextgen from "../../assets/img/nextgen.svg";
import fitbit from "../../assets/img/fitbit.svg";
import dexcom from "../../assets/img/Dexcom.svg";
import oura from "../../assets/img/Oura.svg";
import athenahealth from "../../assets/img/athenahealth.svg";
import garminLogo from "../../assets/img/garminlogo.png";
import ihealthLogo from "../../assets/img/ihealth.png";
import polar from "../../assets/img/polar.svg";
import {
  athenaHandler,
  athenaOneHandler,
  cernerHandler,
  ecwHandler,
  epicHandler,
  getAccessToken,
  getClientTypes,
  getIntegrationTypes,
  platformLogo,
} from "../../utils";
import axios from "axios";
import { API_ENDPOINTS } from "../../api";
import { AppState } from "../../store/types/appState";
import { useDispatch } from "react-redux";
import { showNotification } from "@mantine/notifications";
import { useNavigate } from "react-router-dom";
import noImageAvailabel from "../../assets/img/no-image.svg";
import { ButtonComponent } from "../../components/ButtonComponent";
import { updateProfile } from "../../store/actions/ProfileActions";
import { RedirectingModal } from "../../components/RedirectingModal";
import DeleteModal from "../../components/CustomModal";
import filter from "../../assets/img/filter.svg";

interface ExtensionObject {
  url: string;
  valueString: string;
}
interface ExtensionData {
  url: string;
  extension: ExtensionObject[];
}





const useStyles = createStyles((theme) => ({
  platformLogo: {
    marginRight: "10px",
    width: "25px",
    height: "25px",
  },
  dropdown: {
    maxHeight: "250px",
    overflowY: "auto",
  },
}));
const IntegrationApplication: React.FC = ({}) => {
  const auth = useMedplumContext();
  const dispatch = useDispatch();
  const medplum = useMedplum();
  const { classes } = useStyles();
  const [patientList, setPatientList] = useState<any>([]);
  const [resources, setResources] = useState<any[]>([]);
  const [wearResources, setWearResources] = useState<any[]>([]);
  const [ehrResources, setEhrResources] = useState<any[]>([]);
  const [activeResources, setActiveResources] = useState<any[]>([]);

  const [loading, setLoading] = useState(false);
  const [Ehrfilter, setEhrfilter] = useState(false);
  const [Wearfilter, setWearfilter] = useState(false);

  const [deleteModalVisible, setDeleteModalVisible] = useState(false);
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [pendingDeletion, setPendingDeletion] = useState<{
    id: string;
    resourceType: ResourceType;
  } | null>(null);

  const [vendorName, setVendorName] = useState("");
  const [isRedirecting, setIsRedirecting] = useState(false);
  const logginedUser = useSelector((state: AppState) => state) as any;
  const statuss: any[] = logginedUser?.app?.profile?.extension || [];
  const [userProfile, setUserProfile] = useState<any | undefined>(
    logginedUser.app.profile
  );

  useEffect(() => {
    getPatientNameList();
  }, []);

  function removeExtensionByUrl(
    extension: ExtensionData[],
    urlToRemove: string
  ): ExtensionData[] {
    return extension?.filter((item) => item.url !== urlToRemove);
  }

  const getPatientNameList = async () => {
    const patientList = await medplum.searchResources("Patient");
    setPatientList(patientList);
  };

  async function handleButtonClick(
    e: React.MouseEvent<HTMLButtonElement>,
    resource: any
  ) {
    e.preventDefault();
    e.stopPropagation();

    const buttonText = e.currentTarget.textContent?.toLowerCase();
    const activeLogin = getAccessToken();

    if (buttonText === "connect") {
      const integrationType = getIntegrationTypes(resource?.meta?.extension);
      const resourceType = resource?.resourceType;
      const id = resource?.id;

      setVendorName(integrationType[0]);
      setIsRedirecting(true);

      const historyBundle = await medplum.readHistory(resourceType, id);
      localStorage.setItem("activeClient", JSON.stringify(historyBundle));

      try {
        let authUrl = "";

        if (integrationType[0]?.toLowerCase() === "cerner") {
          const body = {
            eventType: "url",
            clientId: id,
          };

          const res = await cernerHandler(medplum, body);
          if (res.statusCode === 200) {
            authUrl = res.body;
          }
        } else if (integrationType[0]?.toLowerCase() === "athenahealth") {
          const body = {
            eventType: "url",
            clientId: id,
          };

          const res = await athenaHandler(medplum, body);
          if (res.statusCode === 200) {
            authUrl = res.body;
          }
        } else if (
          ["ecw", "eclinicalworks", "nextgen", "athenaone",'veradigm'].includes(
            integrationType[0]?.toLowerCase()
          )
        ) {
          const body = {
            eventType: "url",
            clientId: id,
          };

          const res = await ecwHandler(medplum, body);
          if (res.statusCode === 200) {
            authUrl = res.body;
            
          }

        // } else if (integrationType[0]?.toLowerCase() === "athenaone") {
        //   const body = {
        //     eventType: "url",
        //     clientId: id,
        //   };

        //   const res = await athenaOneHandler(medplum, body);
        //   if (res.statusCode === 200) {
        //     authUrl = res.body;
        //   }
        } else {
          setLoading(true);
          const payload = {
            eventType: "url",
            clientId: id,
          };
          const res = await epicHandler(medplum, payload);
          if (res.status === 200) {
            authUrl = res.body.ehrAuthURL;
          }
        }

        if (authUrl.length) {
          window.location.href = authUrl;
          setLoading(false);
        }
        setLoading(false);
      } catch (error) {
        console.error("Error during external authentication:", error);
        setIsRedirecting(false);
        setLoading(false);
      }
    } else {
      setLoading(true);
      const activeLogin = getAccessToken();
      const userProfileClone = { ...userProfile };

      if (userProfileClone) {
        const newExtension = removeExtensionByUrl(
          userProfileClone?.extension as ExtensionData[],
          `ClientApplication/${resource?.id}`
        );
        userProfileClone.extension = newExtension;
        await axios.put(
          `${API_ENDPOINTS.UPDATE_RESOURCE}/${userProfile?.id}`,
          userProfileClone,
          {
            headers: {
              Authorization: `Bearer ${activeLogin.accessToken}`,
            },
          }
        );
        setUserProfile(userProfileClone);
        dispatch(updateProfile(userProfileClone));
        setLoading(false);
      }
      setLoading(false);
    }
  }

  useEffect(() => {
    const fetchResources = async () => {
      try {
        const count: Number = 100;
        const data = (await medplum.searchResources(
          "ClientApplication",
          "_count=100&_sort=name"
        )).filter((entry) => entry?.meta?.extension?.[0]?.extension?.find((item) => item?.url === "clientType")); 
        
        setResources(data);
        setActiveResources(data);
        const wearables = data.filter((entry) => {
          const extensions = entry?.meta?.extension?.[0]?.extension;
          if (!extensions) return false;
          return extensions.some((obj: any) => obj?.valueString === "Wearable");
        });

        const ehrs = data.filter((entry) => {
          const extensions = entry?.meta?.extension?.[0]?.extension;
          if (!extensions) return false;
          return extensions.some((obj: any) => obj?.valueString === "EHR");
        });
        setWearResources(wearables);
        setEhrResources(ehrs);

        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    };

    fetchResources();
  }, [medplum]);
  const handleClickEhr = () => {
    setActiveResources(ehrResources);
  };

  const handleClickWear = () => {
    setActiveResources(wearResources);
  };
  const handleClickAll = () => {
    setActiveResources(resources);
  };

  const parseExtention = (resource: any) => {
    const meta = resource?.meta;
    if (!meta || !meta.extension || meta.extension.length === 0) {
      return "NA";
    }

    let env = "";
    const data = meta.extension[0].extension || [];
    data.forEach((extension: any) => {
      if (extension.url === "environment") {
        env = extension.valueString;
        return extension.valueString;
      }
    });

    return env === "" ? "NA" : env;
  };
  type ResourceType =
    | "ClientApplication"
    | "Patient"
    | "Practitioner"
    | "RelatedPerson"
    | "AccessPolicy";

  const navigate = useNavigate();
  const onEditClick = (id: string, resourcetype: ResourceType) => {
    navigate(`/client/edit/${resourcetype}/${id}`);
  };
  const HandleConfirmDelete = () => {
    if (pendingDeletion) {
      const { id, resourceType } = pendingDeletion;
      medplum
        .deleteResource(resourceType, id)
        .then((res) => {
          setResources((prevResources) =>
            prevResources.filter((resource) => resource.id !== id)
          );
          showNotification({
            color: "green",
            message: "Deleted Successfully",
            autoClose: true,
          });
          setDeleteModalVisible(false);
          setConfirmDelete(false);
        })
        .catch((err) => {
          showNotification({
            color: "red",
            message: normalizeErrorString(err),
            autoClose: true,
          });
        });
    }
  };
  const CancelDelete = () => {
    setDeleteModalVisible(false);
  };

  const onDeleteClick = (id: string, resourceType: ResourceType) => {
    setDeleteModalVisible(true);
    setPendingDeletion({ id, resourceType });
  };

  const svgExtension = (resource: any) => {
    const data = resource?.meta?.extension?.[0]?.extension || [];
    let integrationType = "NA";

    if (data?.length) {
      data.forEach((extension: any) => {
        if (extension.url === "integrationType") {
          integrationType = extension.valueString.toLowerCase();
        }
      });
    }

    const svgMap: { [integrationType: string]: string } = {
      epic: epic,
      google: gfit,
      cerner: cerner,
      nextgen: nextgen,
      fitbit: fitbit,
      dexcom: dexcom,
      oura: oura,
      athenahealth: athenahealth,
      polar: polar,
      omron: omron,
      withing: withing,
      strava: strava,
      apple: apple,
      ecw: eclinical,
      eclinicalworks: eclinical,
      garmin: garminLogo,
      ihealth: ihealthLogo,
      athenaone: athenahealth,
      veradigm:platformLogo['veradigm']
    };

    let svgComponent = noImageAvailabel;

    for (const key in svgMap) {
      if (integrationType.includes(key)) {
        svgComponent = svgMap[key];
        break;
      }
    }

    return svgComponent;
  };

  async function handleWearableButtonClick(
    e: React.MouseEvent<HTMLButtonElement>,
    clientResource: any,
    patientId: string
  ) {
    e.stopPropagation();
    localStorage.setItem("activeClient", JSON.stringify(clientResource));
    localStorage.setItem("selectedPatient", patientId);
    let vendor = "";
    const secret = clientResource.secret;
    const id = clientResource.id;
    const integrationType = getIntegrationTypes(clientResource.meta.extension);
    if (integrationType.length > 0) {
      vendor = integrationType[0];
    }
    setVendorName(vendor);
    setIsRedirecting(true);

    let apiPayload =
      vendor === "Garmin" || vendor === "iHealth"
        ? {
            eventType: "authUrl",
            clientId: id,
            patientId: patientId,
          }
        : {
            type: "url",
            client_id: id,
            secret: secret,
          };

    try {
      let botId = {};
      if (vendor === "Fitbit") {
        botId = {
          system: "https://api-stage.healthconnect.systems/bots",
          value: "fit-bit-service",
        };
      } else if (vendor === "Oura") {
        botId = {
          system: "https://api-stage.healthconnect.systems/bots",
          value: "oura-service",
        };
      } else if (vendor === "Google Fit") {
        botId = {
          system: "https://api-stage.healthconnect.systems/bots",
          value: "google-fit-service",
        };
      } else if (vendor === "Dexcom") {
        botId = {
          system: "https://api-stage.healthconnect.systems/bots",
          value: "dexcom-service",
        };
      } else if (vendor === "Polar") {
        botId = {
          system: "https://api-stage.healthconnect.systems/bots",
          value: "polar-service-new",
        };
      } else if (vendor === "Withings") {
        botId = {
          system: "https://api-stage.healthconnect.systems/bots",
          value: "withing-service",
        };
      } else if (vendor === "Garmin") {
        botId = {
          system: "https://api-stage.healthconnect.systems/bots",
          value: "garmin-service",
        };
      } else if (vendor === "iHealth") {
        botId = {
          system: "https://api-stage.healthconnect.systems/bots",
          value: "iHealth-service",
        };
      } else {
        botId = {
          system: "https://api-stage.healthconnect.systems/bots",
          value: "strava-service",
        };
      }
      const result = await medplum.executeBot(botId, apiPayload);
      if (result.statusCode === 301) {
        let redirectUrl;
        if (vendor === "iHealth") {
          redirectUrl = result.body.authUrl;
        } else {
          redirectUrl = result.body;
        }
        window.location.href = redirectUrl;
      } else if (vendor === "Garmin") {
        localStorage.setItem(
          "GARMIN_AUTH",
          JSON.stringify(result?.body?.oauth)
        );
        window.location.href = result.body.auth_url;
      } else {
        setIsRedirecting(false);
      }
    } catch (error: any) {
      console.error("Error during external authentication:", error);
      setIsRedirecting(false);
    }
  }
  const getClientType = (resource: any): string => {
    const extensions = resource?.meta?.extension || [];
    for (const extension of extensions) {
      if (extension.url === "clientType" && extension.valueString) {
        return extension.valueString;
      }
    }
    return ""; // Default value if client type is not found
  };
  const getPatientName = (patientData: any) => {
    let name = "--";
    if (patientData?.length > 0) {
      patientData.forEach((res: any) => {
        if (
          (res?.use === "official" || res?.use === "usual") &&
          name === "--"
        ) {
          name = res?.text || res?.given[0];
        }
      });
      if (name === "--")
        name = patientData[0]?.text || patientData[0]?.given || "--";
      if (typeof name !== "string") {
        name = String(name);
      }
    }
    return name;
  };

  function hasTopLevelUrl(
    extension: ExtensionData[] | undefined,
    urlToCheck: string
  ): boolean {
    return !!extension && extension?.some((data) => data.url === urlToCheck);
  }

  const getConnectButton = (resource: any) => {
    const clientTypes = getClientTypes(resource?.meta?.extension);
    const integrationType = getIntegrationTypes(resource?.meta?.extension);
    if (clientTypes?.includes("Wearable")) {
      return (
        <Menu shadow="md" width={200}>
          <Menu.Target>
            <Button
              variant="filled"
              onClick={(e) => {
                e.stopPropagation();
              }}
            >
              <Box />
              Connect
            </Button>
          </Menu.Target>
          <Menu.Dropdown className={classes.dropdown}>
            {patientList.map((patient: any) => {
              return (
                <Fragment key={patient.id}>
                  <Menu.Item
                    onClick={(e) =>
                      handleWearableButtonClick(e, resource, patient.id)
                    }
                    icon={<Avatar radius="xl" />}
                  >
                    {getPatientName(patient.name)}
                  </Menu.Item>
                  <Menu.Divider />
                </Fragment>
              );
            })}
          </Menu.Dropdown>
        </Menu>
      );
    } else {
      return (
        <ButtonComponent
          resource={resource}
          userProfile={userProfile}
          handleLaunchClick={(e) => handleButtonClick(e, resource)}
          classes={classes}
          hasTopLevelUrl={hasTopLevelUrl}
        />
      );
    }
  };

  return (
    <>
      {deleteModalVisible && (
        <ConfirmModal
          isOpen={deleteModalVisible}
          onClose={() => {
            setDeleteModalVisible(false);
          }}
          title="Delete Client"
          message="Are you sure you want to delete this ClientApplication?"
          onCancel={CancelDelete}
          onConfirm={HandleConfirmDelete}
          Button1="No"
          Button2="Delete"
        />
      )}
      <RedirectingModal
        isOpen={isRedirecting}
        onClose={() => setIsRedirecting(false)}
        vendor={vendorName}
        text={"Redirecting..."}
      />
      <Box>
        <Layout
          name="Applications"
          button={filter}
          clickEhr={handleClickEhr}
          clickWear={handleClickWear}
          clickAll={handleClickAll}
        />
        {loading && (
          <Box
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 9999,
            }}
          >
            <Loader />
          </Box>
        )}

        <Box
          sx={{
            display: "flex",
            marginBottom: "16px",
            flexDirection: "row",
            flexWrap: "wrap",
            gap: "16px",
            width: "100%",
          }}
        >
          {activeResources &&
            activeResources.map((resource) => {
              let status = "Not Connected";

              if (
                resource.id &&
                auth &&
                auth.profile &&
                auth.profile.extension
              ) {
                statuss?.forEach((item) => {
                  if (item.url) {
                    const itemId = item.url.replace("ClientApplication/", "");
                    if (itemId === resource.id) {
                      status = "Connected";
                    }
                  }
                });
              }
              return (
                <ReusableCard
                  key={resource.id}
                  name={resource.name ?? "Name not available"}
                  info={resource.description ?? "Description not available"}
                  title={parseExtention(resource)}
                  src={svgExtension(resource)}
                  buttonclick={(e: any) => handleButtonClick(e, resource)}
                  edit={() => onEditClick(resource.id, resource.resourceType)}
                  deleteClick={() =>
                    onDeleteClick(resource.id, resource.resourceType)
                  }
                  status={status}
                  connectButton={() => getConnectButton(resource)}
                />
              );
            })}
        </Box>
      </Box>
    </>
  );
};

export default IntegrationApplication;
